import React from 'react';

import ComplianceSummaryStrip from './ComplianceSummaryStrip';

const AdvisorComplianceSummaryStrip = (props) => <ComplianceSummaryStrip {...props} />; // isCountLoading forwarded via spread

export default AdvisorComplianceSummaryStrip;
